export default {
    baseUrl: "http://138.201.140.110:8090",
    thumbBaseUrl: "http://138.201.140.110:8090"
}